import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { applyTheme, loadTheme } from './services/themeService';

// Painted before React mounts, so the first frame is already in the right
// scheme — applying it inside an effect shows a white flash on a dark theme.
applyTheme(loadTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
